
import imageCompression from 'browser-image-compression';
function shouldDisableWebWorker() {
    const ua = navigator.userAgent;

    // 1. 判断是否为 iOS 设备 (包含 iPhone, iPad, 以及新版 iPad OS 伪装成 Mac 的情况)
    const isIOS = /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // 2. 提取 iOS 主版本号
        let version = 0;
        const match = ua.match(/OS (\d+)_/); // 匹配 iPhone/旧iPad 的版本号

        if (match) {
            version = parseInt(match[1], 10);
        } else if (navigator.maxTouchPoints > 1) {
            // 新版 iPadOS (13+) 默认使用 Mac 类型的 UA，需要通过系统特性估算，或者兜底策略
            // 如果无法精准获取版本，考虑到老款 iPad 内存同样吃紧，建议保守处理
            version = 15; // 给予一个保守的默认低版本号
        }

        // 3. 如果是 iOS 15 及以下版本，建议关闭 Web Worker
        if (version <= 15) {
            return true;
        }
    }
    return false;
}
let shouldWeb = shouldDisableWebWorker();
//配置压缩选项
const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 3000, // 限制最大宽度或高度为 1000px
    useWebWorker: !shouldWeb,     // 是否开启
    initialQuality: 0.8,    // 设置初始压缩质量为 0.8
};
async function compressImage(imageFile) {
    let compressedFile = null;
    try {
        // 4. 执行压缩，得到 Blob 对象
        const compressedBlob = await imageCompression(imageFile, options);
        compressedFile = new File([compressedBlob], compressedBlob.name, { type: compressedBlob.type });
    } catch (error) {
        console.error('压缩失败:', error);
    }
    return compressedFile;
}
export default compressImage